import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'

import { useUpdateBranchGymMutation, useGetBranchGymByIdQuery } from 'src/api/branchGymApi'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import { IFormInput, formSchema } from '../AddBranchGymModal/useAddBranchGym'


type useEditBranchGymProps = {
  successCallback: () => void
  id: number
}
const useEditBranchGym = ({ successCallback, id }: useEditBranchGymProps) => {
  const [file, setFile] = useState<File | null>(null)
  const [imageUrl, setImageUrl] = useState<string>('')
  const [showUploadImage, setShowUploadImage] = useState(false)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
      about: '',
      address: '',
      latitude: 0,
      longitude: 0,
      rating: 0,
      parentGym: {label:'Choose Parent Gym', value: 0},
      open: '',
      close: '',
    },
  })
  const { data, isFetching, refetch } = useGetBranchGymByIdQuery(id)

  const [updateBranchGym, { isLoading: isLoadingEditBranchGym }] = useUpdateBranchGymMutation()
  const dispatch = useDispatch<AppDispatch>()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)

    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('about', data.about)
    formData.append('address', data.address)
    formData.append('latitude', data.latitude.toString())
    formData.append('longitude', data.longitude.toString())
    formData.append('rating', data.rating.toString())
    formData.append('parent_gym_id', data.parentGym.value.toString())
    formData.append('opened_at', data.open.toString())
    formData.append('closed_at', data.close.toString())
    if (file) {
      formData.append('picture', file)
    }
    updateBranchGym({
      id,
      data: formData,
    })
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Branch gym updated successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to updated branch gym.')
      })
  }
  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  useEffect(() => {
    if (data) {
      setValue('name', data.name)
      setValue('about', data.about)
      setValue('address', data.address)
      setValue('latitude', +data.latitude)
      setValue('longitude', +data.longitude)
      setValue('rating', data.rating)
      if (data.parent_gym) {
        setValue('parentGym', { label: data.parent_gym.name, value: data.parent_gym.id })
      }
      setValue('open', data.opened_at)
      setValue('close', data.closed_at)
      if (data.picture) {
        setImageUrl(data.picture)
      }
    }
  }, [data])

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingEditBranchGym,
    imageUrl,
    showUploadImage,
    handleShowUploadImage: () => setShowUploadImage(true),
  }
}

export default useEditBranchGym
